import { Component } from '@angular/core';
import { ReposicionService } from 'src/app/pages/operations/reposicion/reposicion.service';

@Component({
  selector: 'app-medicamentos-filtro',
  templateUrl: './medicamentos-filtro.component.html',
  styleUrls: ['./medicamentos-filtro.component.css']
})
export class MedicamentosFiltroComponent {
  constructor(private reposicionService: ReposicionService) {}

  filtros = [
    { label: 'Todos los medicamentos', value: 'todos' },
    { label: 'Solo con stock bajo', value: 'stock-bajo' },
    { label: 'Alta rotación', value: 'alta-rotacion' }
  ];

  buscar(event: Event) {
    const valor = (event.target as HTMLInputElement).value;

    this.reposicionService.setFiltroBusqueda(valor);
  }

  cambiarFiltro(valor: string) {
    this.reposicionService.setFiltroTipo(valor);
  }
}
